export const FETCH_SUBMIT_COMPLETE_TASK_REQUEST = 'FETCH_SUBMIT_COMPLETE_TASK_REQUEST'
export const FETCH_SUBMIT_COMPLETE_TASK_SUCCESS = 'FETCH_SUBMIT_COMPLETE_TASK_SUCCESS'
export const FETCH_SUBMIT_COMPLETE_TASK_FALUIRE = 'FETCH_SUBMIT_COMPLETE_TASK_FALUIRE'
